var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowPaginateLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "10px",
    height: "10px",
    viewBox: "0 0 10 10",
    enableBackground: "new 0 0 10 10",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10814",
    transform: "translate(-189 -472)",
    display: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_17748",
    x: 189,
    y: 472,
    display: "inline",
    fill: "none",
    width: 10,
    height: 10
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pol\\xEDgono_43",
    fill: "#6B6B6B",
    d: "M1.719,5l6-3.5v7L1.719,5z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowPaginateLeft);
export default __webpack_public_path__ + "static/media/arrow-paginate-left.f3a8f43535c04229fad6b3b5fe897d91.svg";
export { ForwardRef as ReactComponent };